import { redirect } from '@sveltejs/kit';
import { get } from 'svelte/store';
import { ON_ADMIN_HOST } from '$lib/api/client';
import { auth, bootstrapAuth } from '$lib/stores/auth';
import { adminHostRedirect } from '$lib/utils/routing/navRoutes';
import type { LayoutLoad } from './$types';

// Root layout module: forces the whole app into client-side-only SPA mode.
//
// `ssr = false` disables server-side rendering for every route. The Cloudflare
// Pages host serves the static `index.html` fallback (emitted by adapter-static
// via `fallback: 'index.html'`) for any unmatched path, and SvelteKit's
// client-side router then mounts the requested route in the browser.
//
// We deliberately do NOT set `prerender = true` at the root because the app
// has parameterised routes (e.g., `/sessions/[id]/review`) whose IDs cannot
// be enumerated at build time. In SPA-fallback mode those routes never need
// to be prerendered — they are resolved client-side after the fallback page
// boots. The fallback page itself is generated by adapter-static regardless
// of this setting.
//
// See wiki/deployment.md and SvelteKit's single-page-apps guide.
export const ssr = false;

// The admin host serves the console, and product pages only while impersonating.
export const load: LayoutLoad = async ({ url }) => {
  if (!ON_ADMIN_HOST) return;
  await bootstrapAuth();
  const target = adminHostRedirect(url.pathname, !!get(auth).user?.impersonation);
  if (target) throw redirect(307, target);
};
